import React, { createRef, useLayoutEffect, useRef } from 'react';
import { GridStack } from 'gridstack';
import 'gridstack/dist/gridstack.css';
import { Card } from '../../../../components/card/card';

// const BuildGrid = ({ dashboardItems, setItemsForUpdate }) => {
//   const refs = useRef({});
//   const gridRef = useRef();
//   const gridContainerRef = useRef(null);
//   refs.current = {};
//   if (Object.keys(refs.current)?.length !== dashboardItems?.length) {
//     dashboardItems?.forEach(({ id }) => {
//       refs.current[id] = refs.current[id] || createRef();
//     });
//   }

//   useLayoutEffect(() => {
//     if (!gridRef.current) {
//       const grid = (gridRef.current = GridStack.init(
//         {
//           // acceptWidgets: true,
//           // auto:false
//           // staticGrid:HasPermission("ViewlistHrPerson")
//         },
//         gridContainerRef.current
//       ).on('change', (ev, gsItems) => {
//         const newItems = grid.save(false);
//         // setItems(newItems);
//         setItemsForUpdate(newItems);
//       }));
//     } else {
//       const grid = gridRef.current;
//       const layout = dashboardItems?.map(
//         (a) =>
//           refs.current[a.id].current.gridstackNode || {
//             ...a,
//             el: refs.current[a.id].current,
//           }
//       );
//       grid._ignoreCB = true;
//       grid.load(layout);
//       delete grid._ignoreCB;
//     }

//     return ()=>{

//     }
//   }, [dashboardItems, setItemsForUpdate]);

//   return (
//     <div>
//       <div className="grid-stack" ref={gridContainerRef}>
//         {dashboardItems?.map((item, i) => {
//           //  const isMobile = window.innerWidth < 768;
//           return (
//             <div
//               ref={refs.current[item.id]}
//               key={item.id}
//               className="grid-stack-item"
//               gs-id={item.id}
//               gs-w={item.w}
//               gs-h={item.h}
//               gs-x={item.x}
//               gs-y={item.y}>
//               <Card
//                 className="m-0 p-0"
//                 style={{
//                   height: 'calc(100% - 10px)',
//                   width: 'calc(100% - 10px)',
//                 }}>
//                 <div className="grid-stack-item-content">{item.content}</div>
//               </Card>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

const BuildGrid = ({ dashboardItems, setItemsForUpdate }) => {
  const refs = useRef({});
  const gridRef = useRef(null);
  const gridContainerRef = useRef(null);

  // إنشاء أو تحديث المراجع عند تغيّر dashboardItems
  if (Object.keys(refs.current)?.length !== dashboardItems?.length) {
    dashboardItems?.forEach(({ id }) => {
      if (!refs.current[id]) {
        refs.current[id] = createRef();
      }
    });
  }

  useLayoutEffect(() => {
    // تهيئة GridStack عند أول مرة فقط
    if (!gridRef.current) {
      gridRef.current = GridStack.init({}, gridContainerRef.current).on(
        'change',
        (_, gridStackItems) => {
          const updatedItems = gridRef.current.save(false);
          // console.log(updatedItems);
          
          setItemsForUpdate(updatedItems);
        }
      );
    }

    // تحديث تخطيط الشبكة عند تغيّر dashboardItems
    if (gridRef.current && dashboardItems) {
      const grid = gridRef.current;
      const layout = dashboardItems.map(
        (item) =>
          refs.current[item.id]?.current?.gridstackNode || {
            ...item,
            el: refs.current[item.id]?.current,
          }
      );
      grid._ignoreCB = true;
      grid.load(layout); // تحميل التخطيط الجديد
      delete grid._ignoreCB;
    }

    // تنظيف عند تفكيك المكون
    return () => {
      if (gridRef.current) {
        gridRef.current.destroy(false);
        gridRef.current = null;
      }
    };
  }, [dashboardItems, setItemsForUpdate]);

  return (
    <>
      {/* <div>
        <div className="grid-stack" ref={gridContainerRef}>
          {dashboardItems?.map((item) => (
            <div
              ref={refs.current[item.id]}
              key={item.id}
              className="grid-stack-item"
              gs-id={item.id}
              gs-w={item.w}
              gs-h={item.h}
              gs-x={item.x}
              gs-y={item.y}>
              <Card
                style={{
                  height: 'calc(100% - 15px)',
                  width: 'calc(100% - 15px)',
                }}>
                <div className="grid-stack-item-content" style={{ overflow: 'auto' }}>{item.content}</div>
              </Card>
            </div>
          ))}
        </div>
      </div> */}

      <div className="grid-stack-container">
        <div className="grid-stack" ref={gridContainerRef}>
          {dashboardItems?.map((item) => (
            <div
              ref={refs.current[item.id]}
              key={item.id}
              className="grid-stack-item"
              gs-id={item.id}
              gs-w={item.w}
              gs-h={item.h}
              gs-x={item.x}
              gs-y={item.y}>
              <Card
                style={{
                  height: 'calc(100% - 20px)', // خصم التباعد (10px من الأعلى والأسفل)
                  width: 'calc(100% - 20px)', // خصم التباعد (10px من اليمين واليسار)
                  padding: '10px', // إضافة padding لتحسين التصميم
                }}>
                <div
                  className="grid-stack-item-content"
                  style={{
                    overflow: 'auto',
                    height: '100%', // ضمان أن المحتوى يملأ المساحة بالكامل
                  }}>
                  {item.content}
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BuildGrid;

// {/* <div>
//       <div className="grid-stack" ref={gridContainerRef}>
//         {dashboardItems?.map((item) => (
//           <div
//             ref={refs.current[item.id]}
//             key={item.id}
//             className="grid-stack-item"
//             gs-id={item.id}
//             gs-w={item.w}
//             gs-h={item.h}
//             gs-x={item.x}
//             gs-y={item.y}
//           >
//             <Card
//               className="m-0 p-0"
//               style={{
//                 height: 'calc(100% - 15px)',
//                 width: 'calc(100% - 15px)',
//               }}
//             >
//               <div className="grid-stack-item-content">{item.content}</div>
//             </Card>
//           </div>
//         ))}
//       </div>
//     </div> */}
